import Link from 'next/link';
import { GearThemePrimaryImage } from '../../svgImages/GearImage';
import { PlusThemePrimaryImage } from '../../svgImages/PlusImage';
import type { ButtonLinkProps } from '../types';

export const ButtonLinkSecondary: React.FC<
  ButtonLinkProps & {
    prefixIcon?: 'plus' | 'gear';
  }
> = ({ text, href, width, prefixIcon = null, ...attr }) => (
  <Link
    {...attr}
    href={href}
    passHref
    className={
      width === 'fit'
        ? 'group relative flex min-h-10 w-fit items-center justify-center rounded-2 p-3'
        : 'group relative flex min-h-10 w-full items-center justify-center rounded-2 p-3'
    }
  >
    <div className="absolute inset-0 rounded-2 bg-base-100 transition-colors group-hover:bg-accent-secondary" />
    <div className="absolute inset-0 rounded-2 border-2 border-accent-primary" />
    <div className="relative flex w-fit items-center gap-1">
      {prefixIcon === 'plus' && (
        <PlusThemePrimaryImage alt="" className="size-4" />
      )}
      {prefixIcon === 'gear' && (
        <GearThemePrimaryImage alt="" className="size-4" />
      )}
      <div className="cst-button-label-text text-accent-primary">{text}</div>
    </div>
  </Link>
);
